export { default } from './SpacesTable';
export { default as SpacesTable } from './SpacesTable';
export type { UsageRowData } from './SpacesTable';
